import Api, { handleError } from '@/services/Api';
import axios from 'axios';
import $ from 'jquery';
import store from '@/store';
import constants from '@/shared/constants/constants';

// const API_URL = 'http://localhost:8000/api';
const API_URL = process.env.API_BASE;

export async function getAll(payload) {
  const url = `${API_URL}/project_list/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getCategories() {
  const url = `${API_URL}/category/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function getProjectDetail(id, isReportAll = null, isAnalysis = null) {
  const url = `${API_URL}/project/${id}`;
  const payload = {
    params: { is_report_all: isReportAll, is_analysis: isAnalysis }
  }
  const { status, data } = await Api.get(url, payload).catch(handleError);
  return { status, data };
}

export async function validateProject(payload) {
  const url = `${API_URL}/project_validate/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getSuggestProjectNameApi() {
  const url = `${API_URL}/suggest_project_name/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function postForm(formData) {
  const url = `${API_URL}/create_project/`;
  const token = localStorage.getItem('token');
  const { status, data } = await axios
    .post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `JWT ${token}`,
        'Accept-Language': store.getters.getAccessLanguage,
      },
    })
    .catch(handleError);

  return { status, data };
}

export async function validateSegment(payload) {
  const url = `${API_URL}/segment_validate/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function validateMenu(payload) {
  const url = `${API_URL}/menu_validate/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function uploadImageProject(formData) {
  const url = `${API_URL}/upload_image/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function uploadImageReportAllApi(formData) {
  const url = `${API_URL}/upload_image_report_all/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function downloadReportAllApi(payload) {
  const url = `${API_URL}/download_report_all/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function downloadReportSegmentApi(payload) {
  const url = `${API_URL}/download_report_segment/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function uploadPsdProject(formData) {
  const url = `${API_URL}/upload_psd/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function getAllWord() {
  const url = `${API_URL}/word/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function saveImageWordSelected(formData) {
  const url = `${API_URL}/selected_image_word/`;
  const { message } = await Api.post(url, formData).catch(handleError);
  return { message };
}

export async function downloadFileS3(payload) {
  const url = `${API_URL}/download_file_s3/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function getPathImgProject(payload) {
  const url = `${API_URL}/get_path_img_project/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function cancelJobApi(payload) {
  const url = `${API_URL}/cancel_create_design_task/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function getOldProjectsSurveyApi(payload) {
  const url = `${API_URL}/get_old_projects_survey/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getPresignedUrlUploadScatter(payload) {
  const url = `${API_URL}/get_presigned_url_upload_scatter/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function updateProjectS3Url(payload) {
  const url = `${API_URL}/update_project_s3_url/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function getAllProjectHeatmapShelve(payload) {
  const url = `${API_URL}/get_old_projects_heatmap_shelve/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function exportChatContentText(payload) {
  const url = `${API_URL}/export_chatgpt/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerate(payload) {
  const url = `${API_URL}/create_project_generate/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateDallE3Api(payload) {
  const url = `${API_URL}/create_project_generate_dall_e3/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateFluxProApi(payload) {
  const url = `${API_URL}/create_project_generate_flux_pro/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateGptImage1Api(payload) {
  const url = `${API_URL}/create_project_generate_gpt_image_1/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateSD3Api(payload) {
  const url = `${API_URL}/create_project_generate_sd3/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateGeminiApi(payload) {
  const url = `${API_URL}/create_project_generate_gemini/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function createProjectDeletingApi(payload) {
  const url = `${API_URL}/create_project_deleting/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateImageDallE3Api(payload) {
  const url = `${API_URL}/generate_image_dall_e3/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateImageFluxProApi(payload) {
  const url = `${API_URL}/generate_image_flux_pro/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateImageGptImage1Api(payload) {
  const url = `${API_URL}/generate_image_gpt_image_1/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateImageSD3Api(payload) {
  const url = `${API_URL}/generate_image_sd3/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateImageGeminiApi(payload) {
  const url = `${API_URL}/generate_image_gemini/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateKeyVisualGeminiDirectApi(payload) {
  const url = `${API_URL}/generate_key_visual_gemini_direct/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function generateDeletingBackgroundApi(payload) {
  const url = `${API_URL}/generate_deleting_background/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function deletingBackgroundApi(payload) {
  const url = `${API_URL}/deleting_background/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function downloadZipProjectGenerate(payload) {
  const url = `${API_URL}/generate_imge_zip/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function downloadFileProjectGenerate(payload) {
  const url = `${API_URL}/generate_imge_file/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function progressGenerate(payload) {
  const url = `${API_URL}/generate_imge_progress/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function analysis(formData) {
  const url = `${API_URL}/analysis/`;
  const token = localStorage.getItem('token');
  const { status, data } = await axios
    .post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `JWT ${token}`,
        'Accept-Language': store.getters.getAccessLanguage,
      },
    })
    .catch(handleError);

  return { status, data };
}

export async function getMessageAnalysis(payload) {
  const url = `${API_URL}/message_analysis/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function downloadZipAnalysisApi(payload) {
  const url = `${API_URL}/download_zip_analysis/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function getProcessAnalysisApi(payload) {
  const url = `${API_URL}/process_analysis/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateKeyVisual(payload) {
  const url = `${API_URL}/create_project_generate_key_visual/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function downloadZipTxtKeyVisualApi(payload) {
  const url = `${API_URL}/download_zip_txt_key_visual/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function downloadZipImageKeyVisualApi(payload) {
  const url = `${API_URL}/download_zip_image_key_visual/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function getProcessKeyVisualApi(payload) {
  const url = `${API_URL}/process_key_visual/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function listClientApi() {
  const url = `${API_URL}/list_client/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function exportSalesApi(payload) {
  const url = `${API_URL}/export_sales_management/`;
  const { status, data } = await Api.get(url, { params: payload }, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function exportPlanHistoryApi(payload) {
  const url = `${API_URL}/export_plan_history/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getImagesProjectApi(payload) {
  const url = `${API_URL}/get_images_project/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);

  return { status, data };
}

export async function resizeImageApi(payload) {
  const url = `${API_URL}/resize_image/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function uploadFileLoraApi(formData) {
  const url = `${API_URL}/upload_file_lora/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function similarityReferenceUploadPreviewApi(formData) {
  const url = `${API_URL}/similarity/reference-images/upload-preview/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function uploadSimilarityReferenceSingleImageApi(formData) {
  const url = `${API_URL}/similarity/reference-images/upload-single/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function createSimilarityReferenceUploadJobApi(formData) {
  const url = `${API_URL}/similarity/reference-images/upload-jobs/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function getSimilarityReferenceImageDetailApi(id) {
  const url = `${API_URL}/similarity/reference-images/${id}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function deleteSimilarityReferenceImageApi(id) {
  const url = `${API_URL}/similarity/reference-images/${id}/`;
  const { status, data } = await Api.delete(url).catch(handleError);
  return { status, data };
}

export async function putSimilarityReferenceImageApi(id, payload) {
  const url = `${API_URL}/similarity/reference-images/${id}/`;
  const { status, data } = await Api.put(url, payload).catch(handleError);
  return { status, data };
}

export async function getListLoraApi(payload) {
  const url = `${API_URL}/list_lora/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function uploadPDFAnalysis(formData) {
  const url = `${API_URL}/upload_pdf_analysis/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function uploadPDFConceptValuationAnalysis(projectId, reportId, formData) {
  const url = `${API_URL}/concept_valuation/${projectId}/analysis_report/${reportId}/upload_pdf/`;
  const { status, data } = await Api.post(url, formData).catch(handleError);
  return { status, data };
}

export async function downloadZipConceptValuationAnalysisReportApi(projectId) {
  const url = `${API_URL}/concept_valuation/${projectId}/analysis_report/download_zip/`;
  const { status, data } = await Api.post(url, {}, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function downloadPDFAnalysis(payload) {
  const url = `${API_URL}/download_pdf_analysis/`;
  const response = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { response };
}

export async function getProcessCalculateSurveyApi(payload) {
  const url = `${API_URL}/process_calculate_survey/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getProcessConceptValuationApi(payload) {
  const url = `${API_URL}/process_concept_valuation/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getSimilarityLevelJobStatusApi({ project_id }) {
  const url = `${API_URL}/similarity_job_status/${project_id}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function getSimilarityLevelJobResultApi({ project_id }) {
  const url = `${API_URL}/similarity_job_result/${project_id}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function getHeatmapPredictApi(payload) {
  const url = `${API_URL}/get_heatmap_predict/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getHeatmapShelvePredictApi(payload) {
  const url = `${API_URL}/get_heatmap_shelve_predict/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

/**
 * Converts only the first page of a PDF file to an image format by sending a POST request to the server.
 */
export async function convertPDFToImage(payload) {
  const url = `${API_URL}/convert_pdf_to_jpeg/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function getServiceNotice(payload) {
  const url = `${API_URL}/get_service_notice/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function extractDataFileDocument(payload) {
  const url = `${API_URL}/extract_data_file_document/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}
export async function getPromptAssistApi(payload) {
  const url = `${API_URL}/get_prompt_assist/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getPromptKeyVisualGeminiApi(payload) {
  const url = `${API_URL}/get_prompt_key_visual_gemini/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function createProjectGenerateConceptApi(payload) {
  const url = `${API_URL}/create_project_generate_concept/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function getProjectGenerateConceptApi(payload) {
  const url = `${API_URL}/get_project_generate_concept/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getGeneratePlanConceptSettingApi(planId) {
  const url = `${API_URL}/generate_plan_concept_setting/`;
  const { status, data } = await Api.get(url, { params: { plan_id: planId } }).catch(handleError);
  return { status, data };
}

export async function postGeneratePlanConceptSettingApi(payload) {
  const url = `${API_URL}/generate_plan_concept_setting/`;
  const { status, data } = await Api.post(url, payload, {}).catch(handleError);
  return { status, data };
}

export async function exportGenerateConceptApi(payload) {
  const url = `${API_URL}/export_generate_concept/`;
  const response = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { response };
}

export async function listEditGenerateConceptApi(params) {
  const url = `${API_URL}/list_edit_generate_concept/`;
  const { status, data } = await Api.get(url, { params }).catch(handleError);
  return { status, data };
}

export async function editGenerateConceptApi(payload) {
  const url = `${API_URL}/edit_generate_concept/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function validateBrandCompanyApi(payload) {
  const url = `${API_URL}/validate_brand_company/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getGeneratePromptReferenceStatusApi() {
  const url = `${API_URL}/generate_prompt_reference_status/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function getAutoGenerate30StatusApi(projectId = null) {
  const url = `${API_URL}/auto_generate_30/status/`;
  const config = projectId ? {
    params: {
      project_id: projectId,
    },
  } : undefined;
  const { status, data } = await Api.get(url, config).catch(handleError);
  return { status, data };
}

export async function extractProductInformationDocumentApi(payload) {
  const url = `${API_URL}/auto_generate_30/extract_product_information_document/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function createProjectAutoGenerate30Api(payload) {
  const url = `${API_URL}/create_project_auto_generate_30/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function generateImageGenerate30TestApi(payload) {
  const url = `${API_URL}/generate_image_generate_30_test/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function generateImageGenerate30RemainingApi(payload) {
  const url = `${API_URL}/generate_image_generate_30_remaining/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getAutoGenerate30ResultsApi(projectId) {
  const url = `${API_URL}/auto_generate_30/results/${projectId}/`;
  try {
    const { status, data } = await Api.get(url);
    return { status, data };
  } catch (error) {
    const response = error && error.response ? error.response : null;
    if (response) {
      return { status: response.status, data: response.data };
    }
    throw error;
  }
}

export async function exportEditGenerateConceptApi(payload) {
  const url = `${API_URL}/export_edit_generate_concept/`;
  const response = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { response };
}

export async function getSuggestKeywordsApi(payload) {
  const url = `${API_URL}/get_suggest_keywords/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getSuggestBusinessContextPromptAssist(payload) {
  const url = `${API_URL}/get_suggest_business_context_prompt_assist/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function validateConceptApi(payload) {
  const url = `${API_URL}/validate_concept/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getConceptAssistApi(payload) {
  const url = `${API_URL}/get_concept_assist/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function downloadCsvPromptGenerateApi(payload) {
  const url = `${API_URL}/download_csv_prompt_generate/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function downloadZipInputImageGenerateApi(payload) {
  const url = `${API_URL}/download_zip_input_image_generate/`;
  const { status, data } = await Api.post(url, payload, { responseType: 'blob' }).catch(handleError);
  return { status, data };
}

export async function calculateScoreGenerateApi(payload) {
  const url = `${API_URL}/calculate_score_generate/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function checkTrademarkApi(payload) {
  const url = `${API_URL}/check_trademark/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function checkLawApi(payload) {
  const url = `${API_URL}/check_law/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function exportCsvLawCheckApi(payload) {
  const url = `${API_URL}/export_csv_law_check/`;
  const { status, data } = await Api.get(url, {
    params: payload,
    responseType: 'blob',
  }).catch(handleError);
  return { status, data };
}

export async function exportCsvCatchCopyApi(payload) {
  const url = `${API_URL}/export_csv_catch_copy/`;
  const { status, data } = await Api.get(url, {
    params: payload,
    responseType: 'blob',
  }).catch(handleError);
  return { status, data };
}

export async function getProcessCheckTrademarkApi(payload) {
  const url = `${API_URL}/process_check_trademark/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getOldProjectsConceptValuationApi(payload) {
  const url = `${API_URL}/get_old_projects_concept_valuation/`;
  const { status, data } = await Api.get(url, { params: payload }).catch(handleError);
  return { status, data };
}

export async function getOldProjectListConceptValuationApi(payload) {
  const url = `${API_URL}/old_project_list_concept_valuation/`;
  const { status, data } = await Api.get(url, {
    params: payload,
    paramsSerializer: params => $.param(params),
  }).catch(handleError);
  return { status, data };
}

export async function conceptValuationMenuValidate(payload) {
  const url = `${API_URL}/concept_valuation/menu_validate/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function conceptEvaluationCreate(payload) {
  const url = `${API_URL}/concept_valuation/create/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function conceptEvaluationDetail(projectId) {
  const url = `${API_URL}/concept_valuation/${projectId}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function conceptEvaluationGenerateConceptTitles(concepts) {
  const url = `${API_URL}/concept_valuation/generate_concept_titles/`;
  const { status, data } = await Api.post(url, { concepts }).catch(handleError);
  return { status, data };
}

export async function conceptEvaluationCategoryList() {
  const url = `${API_URL}/concept_valuation/categories/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function conceptEvaluationCreateAnalysisReport(projectId, itemId) {
  const url = `${API_URL}/concept_valuation/${projectId}/analysis_report/`;
  const response = await Api.post(url, { item_id: itemId }).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  const { status, data } = response;
  return { status, data };
}

export async function conceptEvaluationAnalysisReportDetail(projectId, reportId) {
  const url = `${API_URL}/concept_valuation/${projectId}/analysis_report/${reportId}/`;
  const response = await Api.get(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  const { status, data } = response;
  return { status, data };
}
